import React from 'react';

const newsData = [
  {
    id: 1,
    category: 'Experience a comfortable and hassle-free journey with our Pune to Ashtavinayak Cab Service. Whether you are planning a religious pilgrimage or just exploring the sacred temples, S9 Travels ensures a safe and smooth ride with our professional drivers and well-maintained vehicles.',
    date: '20 Mar, 2023',
    title: 'Pune To Ashtavinayak Cab Service',
    image: '/images/keyword/31.jpg',
    link: '',
    content: ''
  },
  {
    id: 2,
    category: 'Planning a trip to the scenic hill station of Mahabaleshwar? Book our Pune to Mahabaleshwar Innova Cab for a comfortable and enjoyable ride. With spacious vehicles and reliable service, S9 Travels makes your trip to Mahabaleshwar relaxing and memorable.',
    date: '19 Mar, 2023',
    title: 'Pune to Mahabaleshwar Innova Cab',
    image: '/images/keyword/34.jpg',
    link: '',
    content: ''
  },
  {
    id: 3,
    category: 'Discover the stunning beauty of the Konkan region with our Mumbai to Konkan Darshan Cab Service. Explore picturesque coastal towns, pristine beaches, and historic forts with S9 Travels, your trusted travel companion for a peaceful and scenic journey.',
    date: '18 Mar, 2023',
    title: 'Mumbai to Konkan Darshan',
    image: '/images/keyword/56.jpg',
    link: '',
    content: ''
  },
];


const NewsSection = () => {
  return (
    <section className="news-section pt_100 pb_65">
      <div className="auto-container">
        <div className="sec-title centred mb_50">
          {/* <span className="sub-title">Our Blog</span> */}
          <h2>Our Recent Tours</h2>
        </div>
        <div className="row clearfix">
          {newsData.map((news, index) => (
            <div key={news.id} className="col-lg-4 col-md-6 col-sm-12 news-block bg-darkkk">
              <div
                className="news-block-one wow fadeInUp animated "
                data-wow-delay={`${index * 300}ms`}
                data-wow-duration="1500ms"
              >
                <div className="inner-box borderr p-2">
                  <figure className="image-box">
                    <a href={news.link}>
                      <img src={news.image} alt={`News ${news.id}`} />
                    </a>
                  </figure>
                  <div className="lower-content ">
                    <ul className="post-info mb_15">
                     
                    </ul>
                    <h5><a href={news.link}>{news.title}</a></h5>
                    <p className='text-white'>{news.category}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
